module.exports = __webpack_public_path__ + "img/192.6f56b6ae.jpg";